module.exports = __webpack_public_path__ + "img/01.d7e9e2f5.jpg";